/* ================================================================
 * Bisou Rivage — bisou-frame-link.js
 * ----------------------------------------------------------------
 * Quand on clique un lien produit depuis n'importe quelle grille
 * (collection, featured, « Associez le », more like this, wishlist…),
 * si la carte d'origine connaît la finition affichée (data-bisou-frame),
 * on la transmet à la fiche produit via ?frame=<couleur>. La PDP
 * (bisou-variant-ui.js) ouvre alors sur la même couleur de cadre.
 * Chargé globalement (toutes les pages).
 * ================================================================ */
(function () {
  'use strict';
  var VALID = { none: 1, noir: 1, blanc: 1, chene: 1, bouleau: 1 };

  function frameFor(anchor) {
    var node = anchor;
    while (node && node.nodeType === 1) {
      if (node.hasAttribute && node.hasAttribute('data-bisou-frame')) {
        return (node.getAttribute('data-bisou-frame') || '').toLowerCase();
      }
      node = node.parentElement;
    }
    return '';
  }

  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href*="/products/"]') : null;
    if (!a) return;
    var href = a.getAttribute('href');
    if (!href || href.indexOf('/products/') === -1) return;
    if (/[?&]frame=/.test(href)) return;
    var col = frameFor(a);
    if (!VALID[col]) return;
    var hash = '';
    var hi = href.indexOf('#');
    if (hi >= 0) { hash = href.slice(hi); href = href.slice(0, hi); }
    href += (href.indexOf('?') === -1 ? '?' : '&') + 'frame=' + col + hash;
    a.setAttribute('href', href);
  }, true);
})();
